import { AuthContext as GlobalAuthContext } from '@centra/ui-global-context';
import { IAuthContext } from './models';

export const AuthContext = GlobalAuthContext as unknown as React.Context<IAuthContext>;
